import { createSlice } from "@reduxjs/toolkit";
import { } from "../action/authAction";
import {
  blockUnblockedUser,
  deleteUser,
  fetchUsers,
  filterUser,
  getdashboard,
  getVarificationData,
  verifiedUser,
  rejectUser,
  fetchUserDetail
} from "../action/userAction";

const initialState = {
  isLoading: false,
  userList: [],
  selectedUser: {},
  deleteUser: {},
  blockUnblockedUser: {},
  verificationdata: [],
  dashboard: {},
};

export const userSlice = createSlice({
  name: "user",
  initialState: initialState,
  reducers: {
    setSelectedUser: (state, action) => {
      state.selectedUser = action.payload;
    },
  },
  extraReducers: (builder) => {
    // fetch-users
    builder.addCase(fetchUsers.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUsers.fulfilled, (state, action) => {
      // const { data, success } = action?.payload ?? [];
      // state.selectedUser =  data[0];
      const { data = [], success } = action.payload || {};
      state.selectedUser = data.length > 0 ? data[0] : {};
      state.userList = data;
      state.isLoading = false;
    });
    builder.addCase(fetchUsers.rejected, (state, action) => {
      state.isLoading = false;
    });

    // fetch-user-detail
    builder.addCase(fetchUserDetail.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchUserDetail.fulfilled, (state, action) => {

      const { data = {} } = action.payload || {};
      state.userData = data;
      state.isLoading = false;
    });
    builder.addCase(fetchUserDetail.rejected, (state, action) => {
      state.isLoading = false;
    });

    // delete-user
    builder.addCase(deleteUser.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(deleteUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(deleteUser.rejected, (state, action) => {
      state.isLoading = false;
    });

    // UBlocked-Unblocked-user
    builder.addCase(blockUnblockedUser.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(blockUnblockedUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(blockUnblockedUser.rejected, (state, action) => {
      state.isLoading = false;
    });

    // filter-user
    builder.addCase(filterUser.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.userList = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(filterUser.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(filterUser.pending, (state, action) => {
      state.isLoading = true;
    });

    // get-verification-data
    builder.addCase(getVarificationData.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.verificationdata = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(getVarificationData.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getVarificationData.pending, (state, action) => {
      state.isLoading = true;
    });

    // verify-user
    builder.addCase(verifiedUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(verifiedUser.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(verifiedUser.pending, (state, action) => {
      state.isLoading = true;
    });

    // get-dashboard-data
    builder.addCase(getdashboard.fulfilled, (state, action) => {
      const { data } = action?.payload || {};
      state.dashboard = data ?? [];
      state.isLoading = false;
    });
    builder.addCase(getdashboard.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(getdashboard.pending, (state, action) => {
      state.isLoading = true;
    });

    // rejectUser
    builder.addCase(rejectUser.fulfilled, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(rejectUser.rejected, (state, action) => {
      state.isLoading = false;
    });
    builder.addCase(rejectUser.pending, (state, action) => {
      state.isLoading = true;
    });
  },
});

export const { setSelectedUser } = userSlice?.actions;
export default userSlice.reducer;
